class NavigationController {

  constructor(navigationService, checkout, basket) {
    this.navigationService = navigationService;
    this.checkout = checkout;
    this.basket = basket;
  }

  next () {
    return this.navigationService.next();
  }

  nextDisabled () {
    if (this.basket.empty()
      || this.checkout.saving
      || this.basket.saving
      || !this.basket.hasLoaded) {
      return true;
    }

    return false;
  }
}

NavigationController.$inject = [ 'navigationService', 'checkout', 'basket' ];

export default NavigationController;



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/checkout/controllers/navigation.controller.js